module.exports = __webpack_public_path__ + "static/VS_chat_icon-707fc4e9c3896266de40e13b70cafa2e.jpg";